module.exports = __webpack_public_path__ + "img/video.9c6c4a1a.svg";